import { render, staticRenderFns } from "./BaseDescriptionItem.vue?vue&type=template&id=74562cce&scoped=true"
var script = {}
import style0 from "./BaseDescriptionItem.vue?vue&type=style&index=0&id=74562cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74562cce",
  null
  
)

export default component.exports